import { addressesConstants } from '../constants'

const initialState = {
	addresses: [],
	editingAddress: null,
	isOpenChangeModal: false,
	isOpenNewAddressModal: false,
	addressesOwnerId: null
}

export default function addressesReducer(
	state = initialState,
	{ type, payload, errors }
) {
	switch (type) {
		case addressesConstants.SET_ADDRESSES_OWNER_ID:
			return {
				...state,
				addressesOwnerId: payload
			}

		case addressesConstants.GET:
			return {
				...state,
				addresses: payload
			}

		case addressesConstants.INACTIVATE:
			return {
				...state,
				addresses: payload
			}

		case addressesConstants.ADD_OR_UPDATE:
			return {
				...state,
				addresses: payload
			}

		case addressesConstants.SET_EDITING_ADDRESS_ID:
			return {
				...state,
				editingAddress: payload
			}

		case addressesConstants.OPEN_EDIT_ADDRESS_MODAL:
			return { ...state, isOpenChangeModal: true }

		case addressesConstants.CLOSE_EDIT_ADDRESS_MODAL:
			return {
				...state,
				isOpenChangeModal: false
			}

		case addressesConstants.OPEN_NEW_ADDRESS_MODAL:
			return {
				...state,
				isOpenNewAddressModal: true
			}

		case addressesConstants.CLOSE_NEW_ADDRESS_MODAL:
			return {
				...state,
				isOpenNewAddressModal: false,
				editingAddress: null
			}

		default:
			return state
	}
}
